function Home() {
    return ( <div>
    <h2>hey have fun 💯  🛍️, this is the homepage 🏠</h2>
    </div> );
}

export default Home;